import { Link } from "react-router-dom";
import CarouselTestimonials from "../components/CarouselTestimonials";
import SliderBrands from "../components/SlideBrands";
import "../css/home.css";
import background_home from "../img/background_home.webp";
import boat_viking from "../img/boat_viking.webp";
import gary from "../img/gary.webp";
import { Helmet } from "react-helmet";

export default function Home() {
  return (
    <section className="home">
      <Helmet>
        <title>Yacht maintenance in Panama | Panamarine Repair</title>
        <meta
          name="description"
          content="At Panamarine Repair, we offer specialized repair and maintenance services for yachts, commercial vessels, and logistic support boats in Panama. With over 40 years of experience, we guarantee fast, reliable solutions using genuine YANMAR parts and other leading brands."
        />
        <link rel="canonical" href="https://panamarinerepair.com/" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Panamarine Repair" />
      </Helmet>
      <div className="principal">
        <img
          className="background-img"
          src={background_home}
          alt="Background Panamarine Repair yachts"
        />
        <div className="img-gary">
          <img
            src={gary}
            alt="Gary A. Nichols - Founder of Panamarine Repair"
          />
          <div className="gary">
            <p>
              <span>Gary A. Nichols</span>
              <br />
              Naval engineer
            </p>
          </div>
        </div>

        <div className="text-principal">
          <h1>
            <span>Yacht Maintenance </span> & <br /> Engine Repair in Panama
          </h1>
          <h2 className="name-panamarine">
            PANA<span>M</span>ARINE REPAIR
          </h2>
        </div>
      </div>
      <div className="home-services">
        <h2>
          We offer a wide <span>range of yacht and boat repair services </span>
          in Panama
        </h2>
        <div className="text-home-services">
          <div className="p-services">
            <p>
              Our services include diesel engine repairs, marine transmission
              services, performance upgrades , and more. Whether you're
              navigating the Panama Canal or anchored in the bay, our team
              ensures your <strong>yacht or commercial vessel</strong> remains
              in peak condition for a seamless boating experience.
            </p>
            <Link to="/services" id="servicesHome" className="btn">
              Explore all marine services
            </Link>
          </div>
          <img
            src={boat_viking}
            alt="Luxury yacht in Panama receiving repair and maintenance services"
            className="img-home-services"
          />
        </div>
      </div>

      <div className="testimonials">
        <div className="top-testimonials"></div>
        <h2>
          Get to <span>know our work</span>
        </h2>
        <CarouselTestimonials />
      </div>
      <div className="bottom-testimonials"></div>
      <div className="button-work">
        <Link to="/ourWork" className="btn" id="btn-testimonials">
          Know our work
        </Link>
      </div>

      <div className="brands">
        <h2>
          We work with the best <span>brands services</span>
        </h2>
        <SliderBrands />
      </div>
    </section>
  );
}
